import { useFlysiteUrls } from 'hooks/useFlysiteUrls/useFlysiteUrls';
import { useTranslations } from 'utils/translations/useTranslations';

export const TermsOfUseLink = () => {
  const { termsUrl } = useFlysiteUrls();
  const i18n = useTranslations();

  return (
    <a
      data-testid="terms-of-use-link"
      className="Link"
      href={termsUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {i18n.t('checkout.termsAndConditions.terms_of_use')}
    </a>
  );
};
